<template>
  <v-form>
    <div class="mb-4">
      <transition name="scroll-y-transition">
        <v-row v-if="tabelaPrecoUtilizada">
          <v-col cols="12">
            <v-alert
              type="success"
              outlined
              v-once
              class="rounded-tag-small body-2"
              dismissible>
              Carregamos as formas e prazos de pagamentos iniciais da sua tabela de preço.
            </v-alert>
          </v-col>
        </v-row>
      </transition>
      <v-row dense>
        <v-col cols="12" sm="6">
          <px-autocomplete-comprador
            dense
            required
            label="Local de faturamento"
            class="required rounded-tag-small"
            :error="$v.compra.comprador.$error"
            @blur="$v.compra.comprador.$touch()"
            v-model="compra.comprador"/>
        </v-col>
        <v-col cols="12" sm="6">
          <px-autocomplete-comprador
            dense
            required
            label="Local de entrega"
            class="required rounded-tag-small"
            :error="$v.compra.compradorEntrega.$error"
            @blur="$v.compra.compradorEntrega.$touch()"
            v-model="compra.compradorEntrega"/>
        </v-col>
      </v-row>
      <v-row dense align="center" justify="center">
        <v-col cols="12" sm="7">
          <px-autocomplete-fornecedor dense
                                      show-cnpj
                                      show-codigo
                                      path="fornecedor/score"
                                      v-model="compra.fornecedor"
                                      class="required rounded-tag-small"
                                      @change="onChangeFornecedor"
                                      :error="$v.compra.fornecedor.$error"
                                      @blur="$v.compra.fornecedor.$touch()"
                                      required/>
        </v-col>
        <v-col cols="12" sm="2">
          <px-select-enum dense
                          :clearable="false"
                          :disabled="isEditing"
                          v-model="compra.moeda"
                          :items="opcoesMoedas"
                          :error="$v.compra.moeda.$error"
                          @blur="$v.compra.moeda.$touch()"
                          class="rounded-tag-small required"
                          label="Moeda"/>
        </v-col>
        <v-col cols="12" sm="2">
          <px-date-picker dense
                          class="required"
                          input-class="rounded-tag-small"
                          label="Data da compra *"
                          :error="$v.compra.dataCompra.$error"
                          @blur="$v.compra.dataCompra.$touch()"
                          v-model="compra.dataCompra"/>
        </v-col>
        <v-col cols="1">
          <px-anexo v-model="compra.arquivos" :max="3" @loading="onFileLoad">
            <template v-slot:activator="{ on }">
              <v-btn x-small color="primary" v-on="on">
                Anexos
              </v-btn>
            </template>
          </px-anexo>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col class="d-flex" cols="12" sm="2">
          <px-select-enum dense
                          class="required rounded-tag-small"
                          v-model="compra.formaPagamento"
                          :items="formasPagamentos"
                          @change="onChangeFormaPagamento"
                          :error="$v.compra.formaPagamento.$error"
                          @blur="$v.compra.formaPagamento.$touch()"
                          label="Forma de pagamento"/>
        </v-col>
        <v-col class="d-flex" cols="12" sm="4">
          <px-autocomplete-prazo-pagamento
            dense
            label="Prazo de pagamento"
            :class="isAVista ? 'rounded-tag-small' : 'required rounded-tag-small'"
            :disabled="isAVista"
            :error="$v.compra.prazoPagamento.$error"
            @blur="$v.compra.prazoPagamento.$touch()"
            v-model="compra.prazoPagamento"/>
        </v-col>
        <v-col class="d-flex" cols="12" sm="3">
          <px-autocomplete-modo-de-pagamento
            dense
            label="Modo de pagamento"
            :class="`rounded-tag-small ${isModoPagamentoRequired ? 'required' : ''}`"
            :error="$v.compra.modoPagamento.$error"
            @blur="$v.compra.modoPagamento.$touch()"
            v-model="compra.modoPagamento"/>
        </v-col>
        <v-col cols="12" sm="3">
          <px-input-currency
            dense
            :options="configuracaoMoeda"
            :precision="2"
            label="Saving"
            class="rounded-tag-small"
            ref="saving"
            v-model="compra.saving"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col class="d-flex" cols="12" sm="2">
          <px-select-enum dense
                          class="required rounded-tag-small"
                          label="Tipo de frete"
                          v-model="compra.frete.tipoFrete"
                          :items="tiposFrete"
                          :error="$v.compra.frete.tipoFrete.$error"
                          @blur="$v.compra.frete.tipoFrete.$touch()"
                          @change="onChangeTipoFrete"/>
        </v-col>
        <v-col class="d-flex" cols="12" sm="5">
          <px-autocomplete-transportadora
            dense
            path="fornecedor/score"
            search-by-code
            show-codigo
            :class="`rounded-tag-small ${isTransportadoraRequired ? 'required' : ''}`"
            :error="$v.compra.transportadora.$error"
            @blur="$v.compra.transportadora.$touch()"
            v-model="compra.transportadora"/>
        </v-col>
        <v-col class="d-flex" cols="12" sm="3">
          <px-date-picker dense
                          input-class="required rounded-tag-small"
                          label="Previsão de entrega"
                          :error="$v.compra.dataPrevisaoEntrega.$error"
                          @blur="$v.compra.dataPrevisaoEntrega.$touch()"
                          v-model="compra.dataPrevisaoEntrega"/>
        </v-col>
        <v-col class="d-flex" cols="12" sm="2">
          <px-input-currency
            dense
            :options="configuracaoMoeda"
            :precision="2"
            label="Valor do frete"
            class="required rounded-tag-small"
            ref="totalTransporte"
            :disabled="isFob"
            v-model="compra.frete.totalTransporte"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6">
          <px-autocomplete-projeto
            dense
            class="rounded-tag-small"
            v-model="compra.projeto"/>
        </v-col>
        <v-col cols="12" sm="6">
          <px-autocomplete-centro-custo
            dense
            :class="`rounded-tag-small ${isCentroCustoRequired ? 'required' : ''}`"
            :error="$v.compra.centroCusto.$error"
            @blur="$v.compra.centroCusto.$touch()"
            v-model="compra.centroCusto"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" :sm="smNotaEntrada">
          <px-autocomplete-nota-entrada
            dense
            :class="`rounded-tag-small ${isTipoNotaEntradaRequired ? 'required' : ''}`"
            :error="$v.compra.tipoNotaEntrada.$error"
            @blur="$v.compra.tipoNotaEntrada.$touch()"
            v-model="compra.tipoNotaEntrada"/>
        </v-col>
        <v-col cols="12" sm="3" v-if="isFromSolicitacao">
          <px-date-picker dense
                          input-class="rounded-tag-small"
                          label="Previsao de entrega da solicitacao"
                          v-model="compra.dataNecessidadeEntregaSolicitacao"/>
        </v-col>
        <v-col cols="12" sm="3">
          <px-date-picker dense
                          input-class="required rounded-tag-small"
                          label="Data de faturamento"
                          :error="$v.compra.dataFaturamento.$error"
                          @blur="$v.compra.dataFaturamento.$touch()"
                          v-model="compra.dataFaturamento"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            outlined
            rows="2"
            v-model="compra.observacao"
            label="Observações internas"
            counter="1500"
            class="rounded-tag-small"
          />
        </v-col>
      </v-row>
      <px-campos-integracao dense
                            type="compra"
                            :form-data="cadastrosAdicionais"/>
      <v-row dense class="mt-3">
        <v-col cols="12">
          <div class="font-weight-bold body-2">
            Finalidade da compra
          </div>
          <v-radio-group
            row dense
            v-model="compra.finalidadeCompra"
            class="d-flex"
          >
            <v-radio
              v-for="finalidade in finalidades"
              :key="finalidade.key"
              :label="finalidade.description"
              :value="finalidade.key"/>
          </v-radio-group>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-btn color="primary" class="rounded-tag-small normal-btn-text"
             @click="enviar">Continuar
      </v-btn>
      <v-btn text class="normal-btn-text" @click="onClickCancel">Cancelar</v-btn>
    </div>
  </v-form>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators';
import {
  FinalidadeCompra, FormaPagamento, Moeda, TipoFrete,
} from 'px-business-components';
import validationMixin from '@/mixins/validation-mixin';
import validationFileMixin from '@/mixins/validation-file-mixin';
import { validateCamposErp } from '@/modules/carrinho/finalizacao/campos-erp/validate-campos-erp';
import TabelaPrecoService from '@/modules/tabela-preco/tabela-preco-service';
import { formatToCode } from '@/utils/moment-date-utils';
import moment from 'moment';
import {
  isFieldRequiredEntity,
} from '@/modules/erp-campos-obrigatorios/erp-campos-obrigatorios-utils';
import ConfiguracaoMoedaService from '@/modules/configuracoes-moedas/configuracao-moeda.service';
import moedaMixin from '@/mixins/moeda-mixin';

export default {
  props: {
    compra: Object,
    cadastrosAdicionais: Object,
    camposObrigatorios: Object,
    erpCamposIntegracao: String,
    isFromSolicitacao: {
      type: Boolean,
      default: false,
    },
    usaTabelaPreco: {
      type: Boolean,
      default: false,
    },
    isEditing: {
      type: Boolean,
    },
  },
  mixins: [validationMixin, validationFileMixin, moedaMixin],
  data() {
    return {
      opcoesMoedas: [Moeda.keys.BRL.key],
      tabelaPrecoUtilizada: false,
      formasPagamentos: FormaPagamento.values,
      tiposFrete: TipoFrete.values,
      finalidades: FinalidadeCompra.values,
      finalidadeCompra: FinalidadeCompra.keys.USO_CONSUMO.key,
    };
  },
  computed: {
    moeda() {
      return this.compra.moeda;
    },
    isAVista() {
      return this.compra.formaPagamento !== FormaPagamento.keys.A_PRAZO.key;
    },
    isFob() {
      return this.compra.frete.tipoFrete === TipoFrete.keys.FOB.key;
    },
    isCif() {
      return this.compra.frete.tipoFrete === TipoFrete.keys.CIF.key;
    },
    smNotaEntrada() {
      return this.isFromSolicitacao ? '6' : '9';
    },
    isModoPagamentoRequired() {
      return isFieldRequiredEntity('modoPagamento', this.camposObrigatorios);
    },
    isCentroCustoRequired() {
      return isFieldRequiredEntity('centroCusto', this.camposObrigatorios);
    },
    isTipoNotaEntradaRequired() {
      return isFieldRequiredEntity('tipoNotaEntrada', this.camposObrigatorios);
    },
    isTransportadoraRequired() {
      return isFieldRequiredEntity('transportadora', this.camposObrigatorios);
    },
  },
  methods: {
    onChangeFormaPagamento() {
      this.compra.prazoPagamento = null;
    },
    setTransportadora() {
      if (this.isFob) {
        this.compra.transportadora = this.compra.transportadora ? this.compra.transportadora : null;
      }
      if (this.isCif) {
        this.compra.transportadora = this.compra.transportadora
          ? this.compra.transportadora : this.compra.fornecedor;
      }
    },
    onChangeTipoFrete() {
      this.compra.frete.totalTransporte = 0;
      this.setTransportadora();
    },
    onClickCancel() {
      this.$emit('cancel');
    },
    validateCadastrosAdicionais() {
      const [isValid, message] = validateCamposErp(this.erpCamposIntegracao,
        this.cadastrosAdicionais);
      if (!isValid) {
        this.$toast(message, { color: 'error' });
      }
      return isValid;
    },
    enviar() {
      if (this.validateForm() || this.validateFile() || !this.validateCadastrosAdicionais()) {
        return;
      }
      this.$emit('ready');
    },
    setCamposFromTabela(tabelaPreco) {
      if (this.compra.formaPagamento && this.compra.prazoPagamento) {
        return;
      }

      if (!tabelaPreco.formaPagamento || !tabelaPreco.prazoPagamento) {
        return;
      }
      this.compra.formaPagamento = this.compra.formaPagamento ?? tabelaPreco.formaPagamento;
      this.compra.prazoPagamento = this.compra.prazoPagamento ?? tabelaPreco.prazoPagamento;
      this.tabelaPrecoUtilizada = true;
    },
    getTabelaPrecoCompra() {
      const produtosFilters = this.compra.produtos
        .filter(p => p.produto)
        .map(produto => `produto.id = ${produto.produto.id}`);
      const dataAtual = formatToCode(moment());
      const query = `fornecedor.id = ${this.compra.fornecedor.id} and ativo = true and (${produtosFilters.join(' or ')}) and dataVigenciaInicial <= ${dataAtual} and dataVigenciaFinal >= ${dataAtual}`;
      TabelaPrecoService.getTabelasPreco({
        limit: 1,
        offset: 0,
        query,
      }).then(({ data }) => {
        const tabelas = data.content;
        if (tabelas.length === 0) {
          return;
        }
        const [tabelaPreco] = tabelas;
        this.setCamposFromTabela(tabelaPreco);
      });
    },
    onChangeFornecedor() {
      const hasProdutos = this.compra.produtos && this.compra.produtos.length > 0;
      if (!this.usaTabelaPreco || !this.compra.fornecedor || !hasProdutos) {
        return;
      }
      // se já estiver preenchido, não buscamos da tabela de preço
      const hasFieldsToFill = !this.compra.formaPagamento || !this.compra.prazoPagamento;
      if (!hasFieldsToFill) {
        return;
      }
      this.getTabelaPrecoCompra();
    },
    getConfiguracoesMoedas() {
      ConfiguracaoMoedaService.getConfiguracoesMoedas()
        .then(({ data }) => {
          this.opcoesMoedas = [
            Moeda.keys.BRL.key,
            ...data.map(configuracao => configuracao.moeda),
          ];
        });
    },
  },
  watch: {
    'compra.fornecedor': function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue !== null) {
        this.setTransportadora();
      }
      if (!this.cadastrosAdicionais || this.cadastrosAdicionais.natureza) {
        return;
      }
      this.$emit('change-fornecedor', newValue.id);
    },
  },
  created() {
    this.getConfiguracoesMoedas();
  },
  validations: {
    compra: {
      fornecedor: {
        required,
      },
      comprador: {
        required,
      },
      compradorEntrega: {
        required,
      },
      formaPagamento: {
        required,
      },
      prazoPagamento: {
        required: requiredIf(function () {
          return !this.isAVista;
        }),
      },
      modoPagamento: {
        required: requiredIf(function () {
          return this.isModoPagamentoRequired;
        }),
      },
      centroCusto: {
        required: requiredIf(function () {
          return this.isCentroCustoRequired;
        }),
      },
      tipoNotaEntrada: {
        required: requiredIf(function () {
          return this.isTipoNotaEntradaRequired;
        }),
      },
      transportadora: {
        required: requiredIf(function () {
          return this.isTransportadoraRequired;
        }),
      },
      dataCompra: {
        required,
      },
      dataPrevisaoEntrega: {
        required,
      },
      dataFaturamento: {
        required,
      },
      moeda: {
        required,
      },
      frete: {
        tipoFrete: {
          required,
        },
      },
    },
  },
};
</script>
